import { StatusOption } from '../../utils'

export enum PaymentStatusEnum {
  NA = 'NA', // status for quote
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  PREAUTHORIZATION_COMPLETED = 'PREAUTHORIZATION_COMPLETED',
  DEPOSIT_PAID = 'DEPOSIT_PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  FULLY_PAID = 'FULLY_PAID',
  REFUNDED = 'REFUNDED'
}

export const PaymentStatusEnumMapping: Record<PaymentStatusEnum, StatusOption> = {
  [PaymentStatusEnum.NA]: { label: 'N/A', variant: 'grey' },
  [PaymentStatusEnum.WAITING_FOR_PAYMENT]: { label: 'En attente de paiement', variant: 'yellow' },
  [PaymentStatusEnum.PREAUTHORIZATION_COMPLETED]: {
    label: 'Préautorisation complétée',
    variant: 'blue'
  },
  [PaymentStatusEnum.DEPOSIT_PAID]: { label: 'Acompte payé', variant: 'primary' },
  [PaymentStatusEnum.PARTIALLY_PAID]: { label: 'Partiellement payé', variant: 'purple' },
  [PaymentStatusEnum.FULLY_PAID]: { label: 'Entièrement payé', variant: 'success' },
  [PaymentStatusEnum.REFUNDED]: { label: 'Remboursé', variant: 'secondaryBlue' }
}
